const ClientPage = () => {
  return (
    <div>
      <h1>Client Page</h1>
    </div>
  );
};

export default ClientPage;